import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAIL,
  GET_NOTIFICATIONS_SUCCESS,
  BLUE_TICK_NOTIFICATIONS,
  GET_ART_NOTIFICATION_SUCCESS,
  GET_ART_NOTIFICATION_REQUEST,
  GET_ART_NOTIFICATION_FAIL,
  UPDATE_ARTNOTIFICATION_REQUEST,
  UPDATE_ARTNOTIFICATION_FAIL,
  UPDATE_ARTNOTIFICATION_SUCCESS,
  POST_NOTIFICATION_REQUEST,
  POST_NOTIFICATION_FAIL,
  POST_NOTIFICATION_SUCCESS,
  SEND_NEWSLETTER_EMAIL_REQUEST,
  SEND_NEWSLETTER_EMAIL_FAIL,
  SEND_NEWSLETTER_EMAIL_SUCCESS,
  ADD_NEWSLETTER_EMAIL_REQUEST,
  ADD_NEWSLETTER_EMAIL_FAIL,
  ADD_NEWSLETTER_EMAIL_SUCCESS,
} from "./actionTypes";

export const getNotifications = (data) => ({
  type: GET_NOTIFICATIONS,
  payload: data,
});

export const getNotificationsSuccess = (data) => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: data,
});

export const getNotificationsFail = (error) => ({
  type: GET_NOTIFICATIONS_FAIL,
  payload: error,
});

export const putNotifications = (data, callback) => ({
  type: BLUE_TICK_NOTIFICATIONS,
  payload: { data, callback },
});
/* Get Notifications END */

// get art notification 
export const getArtNotificationsRequest = (data, callback) => ({
  type: GET_ART_NOTIFICATION_REQUEST,
  payload:{ data, callback},
});

export const getArtNotificationsSuccess = (data) => ({
  type: GET_ART_NOTIFICATION_SUCCESS,
  payload: data,
});

export const getArtNotificationsFail = (error) => ({
  type: GET_ART_NOTIFICATION_FAIL,
  payload: error,
});

//update art notification 

export const updateArtNotificationsRequest = (data, callback) => ({
  type: UPDATE_ARTNOTIFICATION_REQUEST,
  payload:{ data, callback},
});

export const updateArtNotificationsSuccess = (data) => ({
  type: UPDATE_ARTNOTIFICATION_SUCCESS,
  payload: data,
});

export const updateArtNotificationsFail = (error) => ({
  type: UPDATE_ARTNOTIFICATION_FAIL,
  payload: error,
});


// post notification 
export const postNotificationRequest = (data, callback) => ({
  type: POST_NOTIFICATION_REQUEST,
  payload:{ data, callback},
});

export const postNotificationSuccess = (data) => ({
  type: POST_NOTIFICATION_SUCCESS,
  payload: data,
});

export const postNotificationFail = (error) => ({
  type: POST_NOTIFICATION_FAIL,
  payload: error,
});

// send newsletter email
export const sendNewsletterEmailRequest = (data, callback) => ({
  type: SEND_NEWSLETTER_EMAIL_REQUEST,
  payload:{ data, callback},
});

export const sendNewsletterEmailSuccess = (data) => ({
  type: SEND_NEWSLETTER_EMAIL_SUCCESS,
  payload: data,
});

export const sendNewsletterEmailFail = (error) => ({
  type: SEND_NEWSLETTER_EMAIL_FAIL,
  payload: error,
});


export const addNewsletterEmailRequest = (data, callback) => ({
  type: ADD_NEWSLETTER_EMAIL_REQUEST,
  payload:{ data, callback},
});

export const addNewsletterEmailSuccess = (data) => ({
  type: ADD_NEWSLETTER_EMAIL_SUCCESS,
  payload: data,
});

export const addNewsletterEmailFail = (error) => ({
  type: ADD_NEWSLETTER_EMAIL_FAIL,
  payload: error,
});


